/**
 * Верхнее меню лендингов (гости):
 * hover-подменю, адаптивный overflow пунктов, мобильный сайдбар, --keysso-top-menu-height.
 */
import './menu.css';

const HOVER_HIDE_DELAY_MS = 200;
const NOTEBOOK_MEDIA_QUERY = '(max-width: 991px)';
const OVERFLOW_EPSILON_PX = 1;

function applyTopMenuHeight(height) {
    document.documentElement.style.setProperty(
        '--keysso-top-menu-height',
        Math.round(height) + 'px'
    );
}

function observeTopMenuHeight(container) {
    if (typeof ResizeObserver === 'undefined') {
        applyTopMenuHeight(container.offsetHeight);
        window.addEventListener('resize', function () {
            applyTopMenuHeight(container.offsetHeight);
        });
        return;
    }

    const observer = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
            let height = entry.contentRect.height;

            if (entry.borderBoxSize && entry.borderBoxSize.length) {
                height = entry.borderBoxSize[0].blockSize;
            }

            applyTopMenuHeight(height);
        });
    });

    observer.observe(container);
}

function isNavOverflowing(nav) {
    const last = nav.lastElementChild;

    if (!last) {
        return false;
    }

    return last.getBoundingClientRect().right > nav.getBoundingClientRect().right + OVERFLOW_EPSILON_PX;
}

/**
 * Прячет невмещающиеся пункты навигации в сабменю «ещё»
 * («Все отчёты и инструменты» всегда только в сабменю).
 */
function fitOverflowNav(nav) {
    const items = Array.prototype.slice.call(nav.querySelectorAll('[data-nav-item]'));
    const morePanel = document.getElementById('submenu-more');

    if (!items.length) {
        return;
    }

    // На мобиле nav скрыт — не трогаем классы, чтобы после ресайза всё пересчиталось чисто
    if (window.getComputedStyle(nav).display === 'none') {
        nav.classList.remove('is-fitted');
        return;
    }

    // Скрываем справа налево, пока содержимое не влезет в доступную ширину.
    // Не сбрасываем все пункты сразу: иначе они мелькают при каждом пересчёте.
    for (let i = items.length - 1; i >= 0; i--) {
        if (!isNavOverflowing(nav)) {
            break;
        }

        items[i].classList.add('is-overflow');
    }

    // Если стало шире — возвращаем пункты слева направо, пока снова не начнут вылезать
    for (let i = 0; i < items.length; i++) {
        if (!items[i].classList.contains('is-overflow')) {
            continue;
        }

        items[i].classList.remove('is-overflow');

        if (isNavOverflowing(nav)) {
            items[i].classList.add('is-overflow');
            break;
        }
    }

    nav.classList.add('is-fitted');

    if (!morePanel) {
        return;
    }

    let overflowCount = 0;

    items.forEach(function (item) {
        const key = item.getAttribute('data-nav-item');
        const mirror = morePanel.querySelector('[data-nav-overflow="' + key + '"]');
        const isOverflow = item.classList.contains('is-overflow');

        if (mirror) {
            mirror.classList.toggle('is-overflow', isOverflow);
        }

        if (isOverflow) {
            overflowCount += 1;
        }
    });

    const divider = morePanel.querySelector('[data-nav-overflow-divider]');

    if (divider) {
        divider.classList.toggle('is-visible', overflowCount > 0);
    }
}

function initOverflowNav(container) {
    const nav = container.querySelector('[data-overflow-nav]');

    if (!nav) {
        return;
    }

    let frameId = 0;

    function scheduleFit() {
        if (frameId) {
            cancelAnimationFrame(frameId);
        }

        frameId = requestAnimationFrame(function () {
            frameId = 0;
            fitOverflowNav(nav);
        });
    }

    fitOverflowNav(nav);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleFit);
    }

    if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', scheduleFit);
        return;
    }

    const observer = new ResizeObserver(scheduleFit);

    observer.observe(nav);
    observer.observe(container);

    const actions = container.querySelector('.menu_top__actions');

    if (actions) {
        observer.observe(actions);
    }
}

function createHoverSubmenu(trigger, panel) {
    let hoverTrigger = false;
    let hoverPanel = false;
    let hideTimer = null;

    function showPanel() {
        clearTimeout(hideTimer);

        const rect = trigger.getBoundingClientRect();
        const edgePadding = 8;
        const align = trigger.getAttribute('data-submenu-align') || 'start';

        panel.classList.add('is-visible');
        panel.style.top = Math.round(rect.bottom + 4) + 'px';
        panel.style.right = 'auto';

        const panelWidth = panel.offsetWidth;
        const minLeft = edgePadding;
        const maxLeft = window.innerWidth - edgePadding - panelWidth;

        function clampLeft(value) {
            if (maxLeft < minLeft) {
                return minLeft;
            }

            return Math.min(Math.max(value, minLeft), maxLeft);
        }

        let left = rect.left;

        // По центру иконки, если не влезает — прижимаем к краю экрана
        if (align === 'center') {
            left = rect.left + (rect.width - panelWidth) / 2;
        } else if (rect.left + panelWidth > window.innerWidth - edgePadding) {
            left = rect.right - panelWidth;
        }

        panel.style.left = Math.round(clampLeft(left)) + 'px';
    }

    function hidePanel() {
        panel.classList.remove('is-visible');
    }

    function scheduleHide() {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
            if (!hoverTrigger && !hoverPanel) {
                hidePanel();
            }
        }, HOVER_HIDE_DELAY_MS);
    }

    trigger.addEventListener('mouseenter', function () {
        hoverTrigger = true;
        showPanel();
    });

    trigger.addEventListener('mouseleave', function () {
        hoverTrigger = false;
        scheduleHide();
    });

    panel.addEventListener('mouseenter', function () {
        hoverPanel = true;
        clearTimeout(hideTimer);
    });

    panel.addEventListener('mouseleave', function () {
        hoverPanel = false;
        scheduleHide();
    });

    trigger.addEventListener('focus', function () {
        hoverTrigger = true;
        showPanel();
    });

    trigger.addEventListener('blur', function () {
        hoverTrigger = false;
        scheduleHide();
    });
}

function initSubmenus() {
    document.querySelectorAll('[data-submenu-trigger]').forEach(function (trigger) {
        const panelId = trigger.getAttribute('data-submenu-trigger');
        const panel = document.getElementById(panelId);

        if (!panel) {
            return;
        }

        // Как в Top.vue: на мобиле дропдаун уведомлений не показываем, только переход по ссылке
        if (panelId === 'submenu-notifications' && window.matchMedia('(max-width: 575px)').matches) {
            return;
        }

        document.body.appendChild(panel);
        createHoverSubmenu(trigger, panel);
    });
}

function closeMobileMenu() {
    const menu = document.getElementById('mobile-menu');

    if (!menu || !menu.classList.contains('is-open')) {
        return;
    }

    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    document.body.classList.remove('menu_mobile_open');

    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
    });
}

function openMobileMenu() {
    const menu = document.getElementById('mobile-menu');

    if (!menu || menu.classList.contains('is-open')) {
        return;
    }

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    menu.removeAttribute('inert');
    document.body.classList.add('menu_mobile_open');

    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
    });
}

function initActions() {
    document.querySelectorAll('.menu_top__open_support').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            if (typeof Verbox === 'function') {
                Verbox('openSupport');
            }

            closeMobileMenu();
        });
    });

    document.querySelectorAll('.menu_top__open_demo').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            if (window.keysoEmitter) {
                window.keysoEmitter.emit('popup-demo-block-open');
            }

            closeMobileMenu();
        });
    });
}

function initMobileMenu() {
    const menu = document.getElementById('mobile-menu');

    if (!menu) {
        return;
    }

    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();

            if (menu.classList.contains('is-open')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    });

    document.querySelectorAll('[data-mobile-menu-close]').forEach(function (overlay) {
        overlay.addEventListener('click', closeMobileMenu);
    });

    menu.querySelectorAll('.menu_mobile__item[href], .menu_mobile__subitem[href]').forEach(function (link) {
        if (link.getAttribute('href') === '#') {
            return;
        }

        link.addEventListener('click', closeMobileMenu);
    });

    menu.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
            const group = button.closest('.menu_mobile__group');
            const subitems = group ? group.querySelector('.menu_mobile__subitems') : null;

            if (!group || !subitems) {
                return;
            }

            const isExpanded = group.classList.toggle('is-expanded');
            button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            subitems.hidden = !isExpanded;
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMobileMenu();
        }
    });

    window.matchMedia(NOTEBOOK_MEDIA_QUERY).addEventListener('change', function (event) {
        if (!event.matches) {
            closeMobileMenu();
        }
    });
}

function apiRequest(container, method, path) {
    const base = (container.getAttribute('data-api-url') || '').replace(/\/$/, '');

    if (!base) {
        return Promise.reject(new Error('API URL is empty'));
    }

    return fetch(base + path, {
        method: method,
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Accept-Language': container.getAttribute('data-locale') || 'ru',
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(function (response) {
        if (!response.ok) {
            throw new Error('Request failed');
        }

        const contentType = response.headers.get('content-type') || '';

        if (contentType.indexOf('application/json') !== -1) {
            return response.json();
        }

        return {};
    });
}

function formatNotifyDate(value) {
    let raw = value;

    if (value && typeof value === 'object' && value.date) {
        raw = value.date;
    }

    const parsed = new Date(String(raw || '').replace(' ', 'T'));

    if (isNaN(parsed.getTime())) {
        return '';
    }

    function pad(num) {
        return num < 10 ? '0' + num : String(num);
    }

    return pad(parsed.getDate())
        + '.'
        + pad(parsed.getMonth() + 1)
        + '.'
        + String(parsed.getFullYear()).slice(2)
        + ' '
        + pad(parsed.getHours())
        + ':'
        + pad(parsed.getMinutes());
}

function updateNotifyBadge(count) {
    const badge = document.querySelector('[data-notify-badge]');

    if (!badge) {
        return;
    }

    if (count > 0) {
        badge.hidden = false;
        badge.textContent = count > 99 ? '99' : String(count);
    } else {
        badge.hidden = true;
        badge.textContent = '0';
    }
}

function renderNotifications(payload) {
    const list = document.querySelector('[data-notify-list]');
    const empty = document.querySelector('[data-notify-empty]');

    if (!list || !empty) {
        updateNotifyBadge(0);
        return;
    }

    const items = payload && Array.isArray(payload.items) ? payload.items : [];
    const count = payload && payload.count ? Number(payload.count) : items.length;

    list.innerHTML = '';

    items.forEach(function (item) {
        const row = document.createElement('div');
        const hasLink = !!(item.link && String(item.link).length);

        row.className = 'menu_top__notify_item' + (hasLink ? ' is-link' : '');
        row.innerHTML =
            '<div class="menu_top__notify_item_content">'
            + '<span class="menu_top__notify_title"></span>'
            + '<span class="menu_top__notify_date"></span>'
            + '</div>';

        row.querySelector('.menu_top__notify_title').textContent = item.title || '';
        row.querySelector('.menu_top__notify_date').textContent = formatNotifyDate(item.startedAt);

        row.querySelector('.menu_top__notify_item_content').addEventListener('click', function () {
            if (!hasLink) {
                return;
            }

            window.open(item.link, '_blank');
        });

        list.appendChild(row);
    });

    empty.hidden = items.length > 0;
    updateNotifyBadge(count);
}

function initNotifications(container) {
    apiRequest(container, 'GET', '/system-notifications/get')
        .then(function (payload) {
            renderNotifications(payload);
        })
        .catch(function () {
            renderNotifications({ count: 0, items: [] });
        });
}

function initTopMenu() {
    const container = document.getElementById('top-menu');

    if (!container) {
        return;
    }

    initOverflowNav(container);
    initSubmenus();
    initActions();
    initMobileMenu();
    initNotifications(container);
    observeTopMenuHeight(container);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopMenu);
} else {
    initTopMenu();
}
